// Module
var code = `<section class="deeplink">

    <app-deeplink-error
        ng-if="\$ctrl.state.loaded && !\$ctrl.state.isValid"
        data="\$ctrl.deeplinkData"
        state="\$ctrl.state">
    </app-deeplink-error>

    <app-deeplink-mobile
        ng-if="\$ctrl.state.loaded && \$ctrl.state.isValid && \$ctrl.state.isMobile"
        data="\$ctrl.deeplinkData"
        state="\$ctrl.state">
    </app-deeplink-mobile>

    <app-deeplink-desktop
        ng-if="\$ctrl.state.loaded && \$ctrl.state.isValid && !\$ctrl.state.isMobile"
        data="\$ctrl.deeplinkData"
        state="\$ctrl.state">
    </app-deeplink-desktop>

</section>
`;
// Exports
export default code;